import {
  createUserWithEmailAndPassword,
  //  getAuth, signInWithRedirect,
  signInWithEmailAndPassword, signInWithPopup, signOut, GoogleAuthProvider
} from "firebase/auth";
import mainAxios from "./index";
import { baseUrl } from "./requestsIndex";
import { auth, googleProvider } from "./firebaseConfig";
import userRequests from "./userRequests";
// import { GoogleAuthProvider, getRedirectResult, getAuth, signInWithRedirect } from "firebase/auth/cordova";
//Register


const register = async (userDetails) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, userDetails.email, userDetails.password);
    let res = await userRequests.createNewUser(auth.currentUser, userDetails)
    localStorage.setItem("access_token", userCredential.user.accessToken);
    return res
  } catch (error) {
    console.log("🚀 ~ file: authRequests.js:23 ~ login ~ error:", error)
    throw error
  }
};
//Login
const login = async (userDetails) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, userDetails.email, userDetails.password)
    let user = await userRequests.getUserDetails(userCredential.user.email)
    localStorage.setItem("access_token", userCredential.user.accessToken);
    return user
    // return userCredential
  } catch (error) {
    console.log("🚀 ~ file: authRequests.js:23 ~ login ~ error:", error)
    throw error
  }
};
//

const googleLogin = () => {
  return new Promise(async (resolve, reject) => {
    try {
      // const providerForCordova = new GoogleAuthProvider();
      // await signInWithPopup(auth, googleProvider)
      // providerForCordova.addScope('profile');
      // providerForCordova.addScope('email');
      googleProvider.addScope('profile');
      googleProvider.addScope('email');
      const result = await signInWithPopup(auth, googleProvider);
      console.log("🚀 ~ returnnewPromise ~ result:", result)

      // await signInWithRedirect(auth, googleProvider);
      let user;
      userRequests.createNewUser(result.user).then(response => {

        user = response;
        console.log("🚀 ~ .then ~ user:", user)
        if (user) {
          localStorage.setItem("access_token", result.user.accessToken);
          resolve(user)
        }
      }).catch(err => reject(err));
      return
      // const authv = getAuth();
      // // Start a sign in process for an unauthenticated user.
      // signInWithRedirect(authv, providerForCordova)
      //   .then((dd) => {
      //     console.log("🚀 ~ .then ~ dd:", dd)
      //     return getRedirectResult(authv);
      //   })
      //   .then((result) => {
      //     console.log("🚀 ~ .then ~ result:", result)
      //     const credential = GoogleAuthProvider.credentialFromResult(result);

      //     // This gives you a Google Access Token.
      //     // You can use it to access the Google API.


      //     // The signed-in user info.

      //     userRequests.createNewUser(authv.currentUser).then(response => {

      //       user = response;
      //       console.log("🚀 ~ .then ~ user:", user)
      //       if (user) {
      //         localStorage.setItem("access_token", authv.currentUser.accessToken);
      //         resolve(user)
      //       }
      //     }).catch(err => reject(err))
      //   }).catch((error) => {
      //     console.log("🚀 ~ .then ~ error:", error)
      //     reject(error)
      //   });

    } catch (error) {
      console.log("🚀 ~ file:~ signInWhithGoggle ~ error:", error)
      reject(error)
    }
  })
}
// const googleLogin = async () => {//TODO: activat this clean and see if it work 
//   try {
//     const authv = getAuth();
//     const provider = new GoogleAuthProvider();
//     provider.addScope('profile');
//     provider.addScope('email');

//     await signInWithRedirect(authv, provider);

//     const result = await getRedirectResult(authv);
//     console.log("🚀 ~ getRedirectResult ~ result:", result);

//     const credential = GoogleAuthProvider.credentialFromResult(result);
//     const user = await userRequests.createNewUser(authv.currentUser);

//     console.log("🚀 ~ userRequests.createNewUser ~ user:", user);

//     if (user) {
//       localStorage.setItem("access_token", authv.currentUser.accessToken);
//       return user;
//     }
//   } catch (error) {
//     console.log("🚀 ~ googleLogin ~ error:", error);
//     throw error;
//   }
// };

//RefreshToken
const refreshToken = (refToken) => {
  let path = "/users/token";
  let config = {
    headers: { Authorization: `bearer ${refToken}` },
  };
  return new Promise(async (resolve, reject) => {
    try {
      let res = await mainAxios.get(`${baseUrl + path}`, config);
      resolve(res);
    } catch (e) {
      reject(e);
    }
  });
};

const logOut = async () => {
  try {
    await signOut(auth)
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  } catch (error) {
    console.log("🚀 ~ file: authRequests.js:54 ~ logOut ~ error:", error)

  }
}
//
//
const authRequets = { logOut, googleLogin, register, login, refreshToken };
export default authRequets;
